import HttpService from './baseHttp'

// 看板查询接口
export const HttpGetLogisticsPanel = (data) => HttpService.get('/api/v2/LogisticsHead/getLogisticsOverview', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });